import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { LegalEntityViewModel } from '@app/_models/_viewModels/legalEntity.viewmodel';
import { UploadFile, NzMessageService } from 'ng-zorro-antd';
import { Media } from '@app/_models/_DTOs/media';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { LegalEntity } from '@app/_models/_DTOs/legalEntity';
import { ResizeService } from '@app/_services/resize.service';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AutonumericOptions } from '@angularfy/autonumeric/lib/autonumeric.model';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { LegalEntityService } from '@app/_services/legalEntity.service';

@Component({
  selector: "app-legal-entity-editor",
  templateUrl: "./legal-entity-editor.component.html",
  styleUrls: ["./legal-entity-editor.component.css"],
})
export class LegalEntityEditorComponent implements OnInit {
  @Input() hiddenFields: string[];
  @Input() disabledFields: string[];
  @Input() legalEntityViewModel: LegalEntityViewModel;
  @Input() isEditing: boolean;
  @Output() doneEditing = new EventEmitter<number>();

  public createForm: NgForm;

  drawerWidth: string;

  isSavingLegalEntity: boolean = false;

  errorMessages = {};

  apiUrl: string;

  private delayTimer;

  constructor(
    private legalEntityService: LegalEntityService,
    private messageService: NzMessageService,
    private resizeService: ResizeService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe((size) => {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    });
  }

  ngOnInit() {
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    }
  }

  resetForm() {
    this.legalEntityViewModel = null;
  }

  finish(legalEntityId: number, form?: NgForm) {
    if (form) {
      form.reset();
    }
    this.legalEntityViewModel = null;
    this.doneEditing.emit(legalEntityId);
  }

  pad(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  saveLegalEntity(form: NgForm) {
    this.isSavingLegalEntity = true;
    if (this.isEditing) {
      this.legalEntityService
        .put(this.legalEntityViewModel, this.legalEntityViewModel.id)
        .subscribe(
          (result) => {
            this.messageService.create(
              "success",
              "Pravna osoba uspješno izmijenjena",
              {
                nzDuration: 3000,
              }
            );
            this.isSavingLegalEntity = false;
            this.finish(this.legalEntityViewModel.id, form);
          },
          (error) => {
            if (error.ParamName) {
              if (form.controls[error.ParamName]) {
                form.controls[error.ParamName].setErrors({ custom: true });
                var errorMessage = error.Message.split("Parameter name")[0];
                this.errorMessages[error.ParamName] = errorMessage;
              }
            }
            this.isSavingLegalEntity = false;
          }
        );
    } else {
      this.legalEntityService
        .post<LegalEntityViewModel>(this.legalEntityViewModel)
        .subscribe(
          (result) => {
            this.messageService.create("success", "Pravna osoba uspješno dodana");
            this.isSavingLegalEntity = false;
            this.finish(result as number, form);
          },
          (error) => {
            if (error.ParamName) {
              if (form.controls[error.ParamName]) {
                form.controls[error.ParamName].setErrors({ custom: true });
                var errorMessage = error.Message.split("Parameter name")[0];
                this.errorMessages[error.ParamName] = errorMessage;
              }
            }
            this.isSavingLegalEntity = false;
          }
        );
    }
  }

  isFieldHidden(fieldName: string) {
    if (this.hiddenFields) {
      if (this.hiddenFields.length > 0) {
        if (this.hiddenFields.some((x) => x == fieldName)) {
          return false;
        }
      }
    }
    return true;
  }

  isFieldEnabled(fieldName: string) {
    if (this.disabledFields) {
      if (this.disabledFields.length > 0) {
        if (this.disabledFields.some((x) => x == fieldName)) {
          return false;
        }
      }
    }
    return true;
  }
}
